import {
    ACTION_FETCHING_MUNICIPALITIES_IN_PROGRESS,
    ACTION_FETCHING_MUNICIPALITIES_COMPLETED,
    ACTION_STORE_FETCHED_MUNICIPALITIES,
    ACTION_FETCHING_MUNICIPALITY_IN_PROGRESS,
    ACTION_FETCHING_MUNICIPALITY_COMPLETED,
    ACTION_STORE_FETCHED_MUNICIPALITY,
    ACTION_SET_MUNICIPALITY_PAGE,
    ACTION_REMOVE_MUNICIPALITY,
    ACTION_SET_MUNICIPALITY_FILTERS,
    ACTION_STORE_ADDITIONAL_MUNICIPALITIES,
    ACTION_CLEAR_MUNICIPALITY_REDUCER,
    ACTION_FETCHING_ALL_MUNICIPALITIES_IN_PROGRESS,
    ACTION_STORE_FETCHED_ALL_MUNICIPALITIES,
    ACTION_FETCHING_ALL_MUNICIPALITIES_COMPLETED,
    ACTION_EDITING_MUNICIPALITY_IN_PROGRESS,
    ACTION_EDITING_MUNICIPALITY_COMPLETED,
    ACTION_FETCHING_MUNICIPALITY_OPTIONS_IN_PROGRESS,
    ACTION_STORE_MUNICIPALITY_OPTIONS,
    ACTION_FETCHING_MUNICIPALITY_OPTIONS_COMPLETED,
    ACTION_CREATING_MUNICIPALITY_IN_PROGRESS,
    ACTION_CREATING_MUNICIPALITY_COMPLETED,
    ACTION_DELETING_MUNICIPALITY_IN_PROGRESS,
    ACTION_DELETING_MUNICIPALITY_COMPLETED,
    ACTION_FETCHING_ADDITIONAL_MUNICIPALITIES_IN_PROGRESS,
    ACTION_FETCHING_ADDITIONAL_MUNICIPALITIES_COMPLETED
} from './municipalityActionsList';

import api from '../../api';
import history from '../router/history';

//? Fetches all the municipalities that match the user selection //
export const getMunicipalities = (filters) => {
    return async (dispatch) => {
        try {
            const page = 1;

            dispatch(ACTION_SET_MUNICIPALITY_PAGE(1));
            dispatch(ACTION_FETCHING_MUNICIPALITIES_IN_PROGRESS());
            
            const response = await api.getMunicipalities(filters, page);
            if(response && response.data){
                dispatch(ACTION_STORE_FETCHED_MUNICIPALITIES(response.data.municipalities, response.data.totalItems));
            }
            dispatch(ACTION_FETCHING_MUNICIPALITIES_COMPLETED());
        } catch (error) {
            
            dispatch(ACTION_FETCHING_MUNICIPALITIES_COMPLETED());
        }   
    }
}


export const getMoreMunicipalities = (filters) => {
    return async (dispatch, getState) => {
        try {
            const page = getState().municipalities.page;

            dispatch(ACTION_FETCHING_ADDITIONAL_MUNICIPALITIES_IN_PROGRESS());
       
            const response = await api.getMunicipalities(filters, page);
            if(response && response.data){
                dispatch(ACTION_STORE_ADDITIONAL_MUNICIPALITIES(response.data.municipalities));
            }
            dispatch(ACTION_FETCHING_ADDITIONAL_MUNICIPALITIES_COMPLETED());
        } catch (error) {
            
            dispatch(ACTION_FETCHING_ADDITIONAL_MUNICIPALITIES_COMPLETED());
        }   
    }
}

//? Fetches a single Municipality //
export const getMunicipality = (id) => {
    return async (dispatch) => {
        try {
            dispatch(ACTION_FETCHING_MUNICIPALITY_IN_PROGRESS());
            const response = await api.getMunicipality(id);
            if(response && response.data){
                dispatch(ACTION_STORE_FETCHED_MUNICIPALITY(response.data.municipality));
            }
            dispatch(ACTION_FETCHING_MUNICIPALITY_COMPLETED());
        } catch (error) {
            
            dispatch(ACTION_FETCHING_MUNICIPALITY_COMPLETED());
        }   
    }
}

export const removeMunicipality = () => {
    return (dispatch) => {
        dispatch(ACTION_REMOVE_MUNICIPALITY());
    }
}

export const setMunicipalityFilters = (filters) => {
    return (dispatch) => {
        dispatch(ACTION_SET_MUNICIPALITY_FILTERS(filters));
    }
}

export const setMunicipalityPage = (page) => {
    return (dispatch) => {
        dispatch(ACTION_SET_MUNICIPALITY_PAGE(page));
    }
}

export const clearMunicipalityState = () => {
     return (dispatch) => {
         dispatch(ACTION_CLEAR_MUNICIPALITY_REDUCER());
     }
}

export const getAllMunicipalities = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(ACTION_FETCHING_ALL_MUNICIPALITIES_IN_PROGRESS());
            const response = await api.getAllMunicipalities();
            if (response?.data?.municipalities) {
                dispatch(ACTION_STORE_FETCHED_ALL_MUNICIPALITIES(response.data.municipalities))
            }
            dispatch(ACTION_FETCHING_ALL_MUNICIPALITIES_COMPLETED());
        } catch (error) {
            dispatch(ACTION_FETCHING_ALL_MUNICIPALITIES_COMPLETED());
        }
    }
}

export const editMunicipality = (municipality, id) => {
    return async (dispatch, getState) => {
        try {
            dispatch(ACTION_EDITING_MUNICIPALITY_IN_PROGRESS());
            const response = await api.editMunicipality(municipality, id);
            if (response?.data?.municipality) {
                history.replace('/dashboard/municipalities');
            }
            dispatch(ACTION_EDITING_MUNICIPALITY_COMPLETED());
        } catch (error) {
            dispatch(ACTION_EDITING_MUNICIPALITY_COMPLETED());
        }
    }
}
export const getMunicipalityOptions = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(ACTION_FETCHING_MUNICIPALITY_OPTIONS_IN_PROGRESS());
            const response = await api.getMunicipalityOptions();
            if (response?.data?.options) {
                dispatch(ACTION_STORE_MUNICIPALITY_OPTIONS(response.data.options))
            }
            dispatch(ACTION_FETCHING_MUNICIPALITY_OPTIONS_COMPLETED());
        } catch (error) {
            dispatch(ACTION_FETCHING_MUNICIPALITY_OPTIONS_COMPLETED());
        }
    }
}

export const createMunicipality = (municipality) => {
    return async (dispatch, getState) => {
        try {
            dispatch(ACTION_CREATING_MUNICIPALITY_IN_PROGRESS());
            const response = await api.createMunicipality(municipality);
            if (response?.data?.municipality) {
                history.replace('/dashboard/municipalities');
            }
            dispatch(ACTION_CREATING_MUNICIPALITY_COMPLETED());
        } catch (error) {
            dispatch(ACTION_CREATING_MUNICIPALITY_COMPLETED());
        }
    }
}

export const deleteMunicipality = (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch(ACTION_DELETING_MUNICIPALITY_IN_PROGRESS());
            await api.deleteMunicipality(id);
            dispatch(ACTION_DELETING_MUNICIPALITY_COMPLETED());
        } catch (error) {
            dispatch(ACTION_DELETING_MUNICIPALITY_COMPLETED());
        }
    }
}